export default __webpack_public_path__ + "f4c55bb57ab1848ea1f7f59481fa97e9.svg";